import { ElDialog } from 'element-ui/types/dialog';

export enum DialogEvents {
	openDialog = 'UI_KIT_DIALOG_OPENED',
	closeDialog = 'UI_KIT_DIALOG_CLOSED'
}

export enum BtnActions {
	Prev = 'prev',
	Next = 'next',
	Start = 'start',
	Submit = 'submit',
	Cancel = 'cancel'
}

export enum BtnTypes {
	Info = 'info',
	Danger = 'danger',
	Primary = 'primary',
	Success = 'success',
	Warning = 'warning'
}

export type IHideFunction = (cancel?: boolean) => void;
export type IBeforeClose = ((done: IHideFunction, status?: BtnActions) => void) | undefined;

export interface IElDialog extends ElDialog {
	hide: IHideFunction;
}
